import { Box, Typography, Button, Paper } from '@mui/material';
import { SearchOff as NotFoundIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
      }}
    >
      <Paper sx={{ p: 4, textAlign: 'center', maxWidth: 400 }}>
        <NotFoundIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
        <Typography variant="h4" gutterBottom>
          404
        </Typography>
        <Typography variant="body1" color="text.secondary" mb={3}>
          {t('error.notFound')}
        </Typography>
        <Button variant="contained" onClick={() => navigate('/')}>
          {t('nav.home')}
        </Button>
      </Paper>
    </Box>
  );
}
